import {
  getColorScheme,
  getContrastYIQ,
} from "@appally/lib/utils/colorSchemes";
import { defineStyleConfig } from "@chakra-ui/react";
import { get } from "lodash";
import { colors } from "../colors";

export const Badge = defineStyleConfig({
  baseStyle: {
    rounded: "full",
    fontWeight: 700,
    px: 3,
    py: 2,
    _disabled: {
      pointerEvents: "none",
      cursor: "not-allowed",
    },
    textTransform: "none",
    transition: "all 0.3s",
    textWrap: "auto",
  },
  sizes: {
    sm: {
      px: 2,
      py: 1,
    },
    lg: {
      fontSize: "lg",
    },
  },
  variants: {
    solid: (props) => {
      const { main, light, dark, text } = getColorScheme(props.colorScheme);
      const _dark = get(colors, dark) as string | undefined;
      return {
        bg: main,
        color: text,
        border: "none",
        _hover: {
          bg: main,
        },
        _disabled: {
          bg: light,
        },
        _dark: {
          bg: dark,
          color: _dark ? getContrastYIQ(_dark) : "white",
        },
      };
    },
    outline: (props) => {
      const { main, tint } = getColorScheme(props.colorScheme);
      return {
        bg: "transparent",
        color: "text",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: main,
        _hover: {
          bg: main,
        },
      };
    },
  },
  defaultProps: {
    variant: "solid",
    colorScheme: "primary",
  },
});
